import { AlignmentConfig } from '@ckeditor/ckeditor5-alignment'

export * from '@ckeditor/ckeditor5-alignment'

declare module '@ckeditor/ckeditor5-core/src/editor/editorconfig' {
  interface EditorConfig {
    alignment?: AlignmentConfig
  }
}
